/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import LoadingBar from 'DesignSystem/LoadingBar/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/Sync/Loading"
  
}) {
  return (<React.Fragment
>
<LoadingBar
  viewPath={`${viewPath}/LoadingBar`}
/>
{children}
</React.Fragment>)
}